import type { ContactOrderPlanColumn } from "../../../_logic/communication-plan-table-contract"

const columns: ContactOrderPlanColumn[] = [
  {
    id: "work",
    label: "Arbeit",
    tooltip: "Termin, Liegenschaft beziehungsweise Wohneinheit und zugehöriger Auftrag.",
    sortable: true,
    sortKey: "work_order_number",
    sortType: "number",
    defaultSortDir: "asc",
  },
  {
    id: "contact",
    label: "Kontakt",
    tooltip: "Empfänger, Kontaktziel, Kanal und Nachrichtenart.",
    sortable: true,
    sortKey: "effective_at",
    sortType: "date",
    defaultSortDir: "desc",
  },
  {
    id: "status",
    label: "Status",
    tooltip:
      "Zeigt, ob die Kontaktaufnahme ansteht, läuft oder beendet ist – und gegebenenfalls warum.",
  },
  {
    id: "hint",
    label: "Hinweis",
    tooltip: "Versandfortschritt und ergänzende Informationen.",
  },
]

export const buildCommunicationPlanColumns = (): ContactOrderPlanColumn[] =>
  columns.map((column) => ({ ...column }))

export const contactOrderPlanColumns: ContactOrderPlanColumn[] = buildCommunicationPlanColumns()
